import { assert } from '@ember/debug';
import Component from '@glimmer/component';
const ALLOWED_LEVELS = ['primary', 'secondary'];
export default class BadgeHighlightComponent extends Component {
  get level() {
    let level = this.args.level ?? 'primary';
    assert('<Badge::Highlight /> can only have those levels: primary or secondary', ALLOWED_LEVELS.includes(level));
    return level;
  }
}